/**
 * Tiny sessionStorage cache for admin dashboard counters. Bumps the
 * perceived speed of /admin and /admin/market by rendering the last
 * known counts instantly while a fresh fetch runs in the background.
 *
 * Lifecycle: bound to the current tab's sessionStorage, so it dies
 * automatically when the admin closes the tab. No TTL needed —
 * fresh counts always overwrite cached ones on every page mount.
 */
const STORAGE_KEY = "vbb_admin_cache_v1";

export function readCache() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("[VBB] adminCache.readCache failed", err);
    }
    return {};
  }
}

export function writeCache(patch) {
  try {
    const current = readCache();
    const next = { ...current, ...patch };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch (err) {
    // sessionStorage write failures (quota, private mode) are non-fatal.
    if (process.env.NODE_ENV !== "production") {
      console.warn("[VBB] adminCache.writeCache failed", err);
    }
  }
}

export function clearCache() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("[VBB] adminCache.clearCache failed", err);
    }
  }
}
